import { render, staticRenderFns } from "./payment-view.vue?vue&type=template&id=4d83dc54&scoped=true"
import script from "./payment-view.vue?vue&type=script&lang=js"
export * from "./payment-view.vue?vue&type=script&lang=js"
import style0 from "./payment-view.vue?vue&type=style&index=0&id=4d83dc54&prod&scoped=true&lang=css"
import style1 from "./payment-view.vue?vue&type=style&index=1&id=4d83dc54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d83dc54",
  null
  
)

export default component.exports